class PdCartModal extends HTMLElement {
  constructor() {
    super();
    this.prevVariantIds = [];

    this.querySelector('.modal__close-button').addEventListener( 'click', this.close.bind(this));
    this.querySelector('.cart-empty__button').addEventListener( 'click', this.close.bind(this));
    this.show.bind(this);
    this.open.bind(this);
    this.close.bind(this);
    this.toggleLoading.bind(this);
    this.handleClickLoginLink();

    document.addEventListener('recommendations::loaded', e => {
      if (e.detail.isCartDrawer) {
        if (!document.querySelector('pd-cart-modal product-recommendations')?.innerHTML.trim()) {
          document.querySelector('pd-cart-modal [data-section-type="ss-recommendations"]')?.classList.remove('d-none');
        }
      }
    });
  }

  handleClickLoginLink() {
    const cartLogin = this.querySelector('[data-cart-login]');
    const openLoginDrawer = document.querySelector('[data-open-login-drawer]');

    if (cartLogin) {
      cartLogin?.addEventListener('click', () => {
        this.close();
        setTimeout(() => {
          openLoginDrawer.click();
        }, 50)
      });
    }
  }

  isOpen() {
    return this.classList.contains('active');
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  markRegistryCart() {
    document.body.setAttribute('registry-cart', 'true');
  }

  unmarkRegistryCart() {
    document.body.removeAttribute('registry-cart');
  }

  show(event) {
    const self = this;
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.querySelector('html').classList.add('overflow-hidden');
  }

  toggleLoading(open) {
    if(open) {
      this.querySelector('[data-loading-state]')?.classList?.remove('hidden');
    } else {
      this.querySelector('[data-loading-state]')?.classList?.add('hidden');
    }
  }

  async open(event, variantIds, productHandle) {
    const self = this;
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.classList.add('active');
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.querySelector('html').classList.add('overflow-hidden');

    const updates = {};
    let hasNoneRegistryItem = false;
    let hasRegistryItem = false;
    const productVariantIdOHand = document.querySelector('product-form .product-variant-id')?.value;
    let productVariantIdsInCart = [];

    this.toggleLoading(false);
    self.loadRecommendation(productHandle);

    if (hasRegistryItem && hasNoneRegistryItem) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      })
    }
  }

  loadRecommendation(productHandle) {
    if (!productHandle) return;
    const ELM_recommendationSections = this.querySelectorAll('[cart-recommendation-section]');

    ELM_recommendationSections?.forEach(ELM_recommendationSection => {
      const { recType, title, ssProfileId } = ELM_recommendationSection.dataset || {};
      const url = `/products/${productHandle}?view=recommendation-carousel&ss_profile_id=${ssProfileId}`;
      ELM_recommendationSection.classList.add('loading');
      fetch(url)
        .then(res => res.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          let HTML_content = '';
          const ELM_complementary = html.querySelector('#shopify-section-pd-complementary-section');
          const ELM_ssRecommendations = html.querySelector('#shopify-section-ss-recommendation');
          const ELM_sectionTitle = html.querySelector('[pd-upsell-section-title]');
          const sectionTitle = ELM_sectionTitle?.innerHTML || title;

          if (ELM_complementary && ELM_complementary.innerHTML) {
            HTML_content = ELM_complementary.innerHTML;
          }

          if (ELM_ssRecommendations) {
            HTML_content += ELM_ssRecommendations.innerHTML;
          }

          if (HTML_content) {
            ELM_recommendationSection.style.display = '';
            ELM_recommendationSection.querySelector('[cart-recommendation-section-content]').innerHTML = `
              <details open>
                <summary class="cart-drawer-recommendations__title">
                  ${sectionTitle}<span class="icon-toggle"></span>
                </summary>
                ${HTML_content}
              </details>`;
            ELM_recommendationSection.querySelector('[data-section-type="ss-recommendations"]')?.classList.add('d-none');
          } else {
            ELM_recommendationSection.querySelector('[cart-recommendation-section-content]').innerHTML = '';
            ELM_recommendationSection.style.display = 'none';
          }
          ELM_recommendationSection.classList.remove('loading');
        })
    })
  }

  close() {
    this.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.querySelector('html').classList.remove('overflow-hidden');
  }
}

customElements.define('pd-cart-modal', PdCartModal);
